import axios from '../../apis/approvalsApi';

export const FETCH_USER_PROFILE_REQUEST = 'FETCH_USER_PROFILE_REQUEST';
export const FETCH_USER_PROFILE_SUCCESS = 'FETCH_USER_PROFILE_SUCCESS';
export const FETCH_USER_PROFILE_FAILURE = 'FETCH_USER_PROFILE_FAILURE';

export const fetchUserProfileRequest = () => ({
    type: FETCH_USER_PROFILE_REQUEST,
});

export const fetchUserProfileSuccess = (data) => ({
    type: FETCH_USER_PROFILE_SUCCESS, payload: data,
});

export const fetchUserProfileFailure = (error) => ({
    type: FETCH_USER_PROFILE_FAILURE, payload: error,
});

/**
 * Action creator for fetching user profile data.
 * @param {string} jwt - JSON Web Token for authentication.
 * @returns {Function} - Async function dispatching actions based on the API response.
 */
export const fetchUserProfileData = (jwt) => async (dispatch) => {
    try {
        // Dispatch the action to indicate that the request is in progress.
        dispatch(fetchUserProfileRequest());

        // Set up the headers for the request, including the JWT for authentication.
        const headers = {
            'Authorization': 'Bearer ' + jwt.accessToken,
        };

        // Make a GET request to the API endpoint for fetching user profile data.
        const response = await axios.get('/user/profile', { headers: headers });

        // Log the response data for debugging purposes.
        //console.log(response);

        // Dispatch an action with the data from the response to indicate success.
        dispatch(fetchUserProfileSuccess(response.data));
    } catch (ex) {
        // Log the error for debugging purposes.
        console.error(ex);

        // If an exception occurs during the request, dispatch an action with the error information.
        dispatch(fetchUserProfileFailure(ex.response?.data || ex.message));
    }
};
